import type { ListItemProps } from "@mui/material";

import { t } from "i18next";

import type { UploadContentProps } from "./types";

import {
  BottomRightBox,
  DocumentUnavailableChip,
  DocumentUnavailableIcon,
  StyledCard,
} from "./UploadStyles/UploadContentStyles";

export function UploadListItem({
  ref,
  children,
  hasDocument,
  loading,
  isDragActive,
  isDragDropEnabled,
  ...rest
}: UploadContentProps &
  Omit<ListItemProps, "children"> & { ref?: React.RefObject<HTMLLIElement | null> }) {
  return (
    <StyledCard
      ref={ref}
      hasDocument={hasDocument}
      isUploading={loading}
      isDragOver={isDragActive}
      isDragDropEnabled={isDragDropEnabled}
      {...rest}
    >
      {!hasDocument && !loading && (
        <BottomRightBox>
          <DocumentUnavailableChip
            label={t("common.actions.doc-warning-label")}
            size="small"
            icon={<DocumentUnavailableIcon component="span">i</DocumentUnavailableIcon>}
          />
        </BottomRightBox>
      )}
      {children}
    </StyledCard>
  );
}
